import * as React from "react";
import { WizardLXPWAProps, WizardLXPWAFTNodeOptions } from "./typings";
import { inject, observer } from "mobx-react";
import { WizardLXPWAView } from "./WizardLXPWAView";
import { normalizeOptionsData } from "src/stores/FlexTemplateStore";

@inject("wizardState", "flexModuleModelStore")
@observer
export class WizardLXPWA extends React.Component<WizardLXPWAProps> {
  private options: WizardLXPWAFTNodeOptions;
  constructor(props: WizardLXPWAProps) {
    super(props);
    const { lxWizardState, globalWizardState } = this.props.wizardState;
    const { location } = this.props.context.searchContext;
    const { flexModuleModelStore, flexTemplateNode } = props;
    const { id } = flexTemplateNode;
    const model = flexModuleModelStore.getModel(id);

    if (model) {
      this.options = normalizeOptionsData(flexTemplateNode, model) as WizardLXPWAFTNodeOptions;
      const { placeholderDestination: setDefaultDestination = true } = this.options;
      const { visibleLobSubtitle } = this.options;
      lxWizardState.overrideConfig(() => {
        lxWizardState.config.elementId = id;
        lxWizardState.config.heading.fixedTitle = this.options.fixedLobTitle;
        lxWizardState.config.lastSearch.useLastSearchForSingleLOB = this.options.useLastSearchForSingleLOB;
        lxWizardState.config.heading.lobSubtitleBreakPoint = this.options.lobSubtitleBreakPoint;
        lxWizardState.config.heading.hideLobTitle = this.options.hideLobTitle;
        lxWizardState.config.heading.visibleLobSubtitle =
          visibleLobSubtitle ?? lxWizardState.config.heading.visibleLobSubtitle;
      });

      if (location != null && setDefaultDestination) {
        lxWizardState.setDefaultDestination(
          location.extendedName,
          location.id,
          location.parent?.code || "",
          location.code,
          "",
          ""
        );
      }

      if (globalWizardState.shouldUpdateCookie) {
        lxWizardState.updateStateFromCookie();
      }
      lxWizardState.updateDateFromConfig();
    }
  }

  public render() {
    if (!this.options) {
      return null;
    }

    return <WizardLXPWAView {...this.props} />;
  }
}

export default WizardLXPWA;
